export enum ActionState {
	THIRD_PARTY_REGISTRATION = 'third_party_login',
	DIRECT_REGISTRATION = 'direct_registration',
	LOGIN = 'login',
	FORGOT_PASSWORD = 'forgot_password',
}
